import { createApp } from 'vue'
import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"
import app from './App.vue'
import router from "./router";
import store from "./store";
import axios from "axios";

import { globalCookiesConfig } from "vue3-cookies";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_HOSTNAME

axios.interceptors.response.use(undefined, function (error) {
    if (error) {
        const originalRequest = error.config;
        if(error.response && error.response.status && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            store.dispatch("ActionLogout");
            return router.push("/denied/");
        }
    }
})

globalCookiesConfig({
    expireTimes: "365d",
    path: "/",
    domain: "",
    secure: true,
    sameSite: "None",
})

import { createRouter, createWebHistory } from 'vue-router'
import PrimeVue, { defaultOptions } from 'primevue/config';
import Dialog from 'primevue/dialog';
import VueCookies from "vue-cookies"
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import Nora from '@primeuix/themes/nora';
import Material from '@primeuix/themes/material';

import Connect from './assets/js/connect.js';
import VueSocketIO from 'vue-socket.io'
import { VueMeta } from 'vue-meta'
import io from 'socket.io-client';
import { createI18n } from 'vue-i18n'

import messages from './lang/index'
const i18n = createI18n({
    locale: 'ru',
    messages: messages,
})

//primevue 
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Dropdown from 'primevue/dropdown';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Card from 'primevue/card';
import Menubar from 'primevue/menubar';
import TabMenu from 'primevue/tabmenu';
import Skeleton from 'primevue/skeleton';
import Tooltip from 'primevue/tooltip';
import Message from 'primevue/message';
import Password from 'primevue/password';
import Menu from 'primevue/menu';
import InputMask from 'primevue/inputmask';
import MultiSelect from 'primevue/multiselect';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Checkbox from 'primevue/checkbox'
import InputSwitch from 'primevue/inputswitch';
import ToggleSwitch  from 'primevue/toggleswitch';
import ToggleButton from 'primevue/togglebutton';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import Timeline from 'primevue/timeline';
import Divider from 'primevue/divider';
import TabView from 'primevue/tabview'; // old
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Knob from 'primevue/knob';

import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
// import AccordionTab from 'primevue/accordiontab';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import SelectButton from 'primevue/selectbutton';
import ProgressSpinner from 'primevue/progressspinner';
import OverlayPanel from 'primevue/overlaypanel';
import Tag from 'primevue/tag';
import Calendar from 'primevue/calendar';
import DatePicker from 'primevue/datepicker';
import Chart from 'primevue/chart';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmPopup from 'primevue/confirmpopup';
import InlineMessage from 'primevue/inlinemessage';
import Paginator from 'primevue/paginator';
import Carousel from 'primevue/carousel';
import Chip from 'primevue/chip';
import RadioButton from 'primevue/radiobutton';
import FileUpload from 'primevue/fileupload';
import 'primeicons/primeicons.css'
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Textarea from 'primevue/textarea';
import Select from 'primevue/select';
import 'chart.js/auto';

//add styles
import '/node_modules/primeflex/primeflex.css'
import './assets/fonts/stylesheet.css'
import './assets/css/main.css'
// import './assets/css/flags.css'

// проверяем на visitorId
const visitorId_store = store.getters.StateUserVisitorId
const visitorId_localstorage = localStorage.getItem('visitorId')

// если есть, то вписываем в store, cookie, localstorage
if(visitorId_store || visitorId_localstorage){
    let visitorId = (visitorId_store) ? visitorId_store : (visitorId_localstorage) ? visitorId_localstorage : null
    localStorage.setItem('visitorId', visitorId)
}

//sokets
// const connect = new Connect()
// const vsocket = new io(process.env.VUE_APP_HOSTNAME, {
//     path: "/socket.io",
//     query: {
//         visitor: store.getters.StateUserVisitorId
//     }
// })

import theme from './assets/js/theme.js' 
const PayWave = definePreset(Aura, theme);

let ap = createApp(app)

// ap.config.globalProperties.$socket = vsocket;
// ap.config.globalProperties.$vueSocketIo = this;

ap
    .use(router)
    .use(store)
    .use(PrimeVue,{
        locale: {
            ...defaultOptions.locale,
            firstDayOfWeek: 1, 
        },
        theme: {
            preset: PayWave,
            options: {
                prefix: 'p',
                // darkModeSelector: 'system',
                darkModeSelector: '.p-app-dark',
                cssLayer: false
            }
        }
    })
    .use(VueCookies)
    .use(ToastService)
    .use(i18n)
    .use(ConfirmationService)
    .use(VueMeta, {
        keyName: 'metaInfo',
        // attribute: 'data-vue-meta',
        // ssrAttribute: 'data-vue-meta-server-rendered',
        // tagIDKeyName: 'vmid',
        refreshOnceOnNavigation: true
    }) 
    .directive('tooltip', Tooltip)
    .component('Button', Button)
    .component('InputText', InputText)
    .component('InputNumber', InputNumber)
    .component('InputGroup', InputGroup)
    .component('InputGroupAddon', InputGroupAddon)
    .component('Dropdown', Dropdown)
    .component('DataTable', DataTable)
    .component('Column', Column)
    .component('Card', Card)
    .component('Divider', Divider)
    .component('Menubar', Menubar)
    .component('TabMenu', TabMenu)
    .component('Skeleton', Skeleton)
    .component('Message', Message)
    .component('Password', Password)
    .component('Menu', Menu)
    .component('InputMask', InputMask)
    .component('MultiSelect', MultiSelect)
    .component('Avatar', Avatar)
    .component('AvatarGroup', AvatarGroup)
    .component('Checkbox', Checkbox)
    .component('InputSwitch', InputSwitch)
    .component('ToggleSwitch', ToggleSwitch)
    .component('ToggleButton', ToggleButton)
    .component('Toast', Toast)
    .component('ProgressBar', ProgressBar)
    .component('TabView', TabView)
    .component('Tabs', Tabs)
    .component('TabList', TabList)
    .component('Tab', Tab)
    .component('TabPanels', TabPanels)
    .component('TabPanel', TabPanel)
    .component('Dialog', Dialog)
    .component('Accordion', Accordion)
    .component('AccordionPanel', AccordionPanel)
    .component('AccordionHeader', AccordionHeader)
    .component('AccordionContent', AccordionContent)
    .component('Badge', Badge)
    .component('SelectButton', SelectButton)
    .component('ProgressSpinner', ProgressSpinner)
    .component('OverlayPanel', OverlayPanel)
    .component('Tag', Tag)
    .component('DatePicker', DatePicker)
    .component('Chart', Chart)
    .component('ConfirmDialog', ConfirmDialog)
    .component('Calendar', Calendar)
    .component('Knob', Knob)
    // .component('TriStateCheckbox', TriStateCheckbox)
    .component('ConfirmPopup', ConfirmPopup)
    .component('InlineMessage', InlineMessage)
    .component('Paginator', Paginator)
    .component('Carousel', Carousel)
    .component('Timeline', Timeline)
    .component('Chip', Chip)
    .component('RadioButton', RadioButton)
    .component('FileUpload', FileUpload)
    .component('IconField', IconField)
    .component('InputIcon', InputIcon)
    .component('Textarea', Textarea)
    .component('Select', Select)
    .directive('badge', BadgeDirective)

ap.mount('#app')